var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-register-pre',{attrs:{"content":_vm.content,"prior-description":_vm.priorDescription},on:{"agree":_vm.agree,"to-login":_vm.toLogin}})
}
var staticRenderFns = []

export { render, staticRenderFns }